<template>
    <div  class="regular-row" @change="sendDataForSaving">
        <div class="date-column">{{ form.date }}</div>
        <div class="location-column">
            <div class="form-group form-group-2 mb-0" >
                <input type="text" class="form-control" v-model="form.location">
            </div>
        </div>
        <div class="in-out-column">
            <div class="form-group form-group-1 mb-0">
                <date-picker
                    v-model="form.time_in"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="HH:MM AM/PM"
                    @close="calculateDifference"
                ></date-picker>
            </div>
        </div>
        <div class="in-out-column">
            <div class="form-group form-group-1 mb-0">
                <date-picker
                    v-model="form.time_out"
                    format="hh:mm a"
                    value-type="format"
                    type="time"
                    placeholder="HH:MM AM/PM"
                    @close="calculateDifference"
                ></date-picker>
            </div>
        </div>
        <div class="hours-column" v-if="form.result">
            {{formatTime(form.result)}}
        </div>
        <div class="hours-column" v-else>
            0
        </div>
    </div>
</template>

<script>
import DateConverter from "../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'DayItem',
    props: {
        day: {
            type: Object,
            required: true
        }
    },
    mixins: [DateConverter],
    data() {
        return {
            form : {
                index: this.day.index,
                date: this.day.date,
                location: this.day.location,
                time_in: this.day.time_in,
                time_out: this.day.time_out,
                result: null,
            },
        }
    },
    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
        calculateDifference() {
            const dateString1 = this.form.date.split('|')[1].trim();
            const timeString1 = this.form.time_in;
            const dates1 = dateString1 + " " + timeString1;

            const dateString2 = this.form.date.split('|')[1].trim();
            const timeString2 = this.form.time_out;
            const dates2 = dateString2 + " " + timeString2;

            const date1 = new Date(dates1);
            const date2 = new Date(dates2);

            let difference = date2.getTime() - date1.getTime();
            if (difference === null) {
                this.form.result = null
            } else {
                this.form.result = difference
            }
            this.sendDataForSaving()
        },
    },
    mounted() {
        this.calculateDifference()
    }
}

</script>

<style scoped>


</style>
